import { clampPivot } from "../customHooks/useZoomControls.jsx";


export const startPanning = (
  event,
  view,
  cameraContainer,
  zoom,
  isSpaceDown  
) => {
  if (!isSpaceDown) return { isPanning: false };  
  event.preventDefault();
  if (zoom > 1) {
    const startMouseX = event.clientX;
    const startMouseY = event.clientY;
    // record the current pivot so we can offset from it
    const { x: startPivotX, y: startPivotY } = cameraContainer.pivot;
  
    // switch cursor to grabbing
    event.currentTarget.style.cursor = "grabbing";
    return {
      isPanning: true,
      startMouseX,
      startMouseY,
      startPivotX,
      startPivotY,
    };
  }

  // view.style.cursor = "grab";
  // if (zoom > 1) {
  //   const rect = view.getBoundingClientRect();
  //   return {
  //     isPanning: true,
  //     startX: event.clientX - rect.left,
  //     startY: event.clientY - rect.top,
  //   };
  // }
  // return { isPanning: false };
};
 
export const movePanning = (
  event,
  state,
  cameraContainer,
  pixiCanvas,
  isSpaceDown  
) => {
  if (!state.isPanning || !isSpaceDown) return state;

  event.preventDefault();

  // calculate raw deltas in screen coords
  const dx = event.clientX - state.startMouseX;
  const dy = event.clientY - state.startMouseY;

  // apply to pivot in world coords
  cameraContainer.pivot.x = state.startPivotX - dx / cameraContainer.scale.x;
  cameraContainer.pivot.y = state.startPivotY - dy / cameraContainer.scale.y;

  // clamp to bounds
  const { width: screenWidth, height: screenHeight } = pixiCanvas.screen;
  clampPivot(cameraContainer, screenWidth, screenHeight);

  return state;  // keep the same start positions
};
 

export const stopPanning = (state, view) => {
  if (state.isPanning) {
    view.style.cursor = "default";
  }
  return { isPanning: false };
};
